import React, { useState, useEffect } from 'react';
import * as Yup from 'yup';
import { Formik, FieldArray } from 'formik';
import {
  CForm,
  CRow,
  CCol,
  CSelect,
  CFormText,
  CButton,
  CButtonClose,
  CFormGroup,
  CLabel,
  CInputCheckbox,
} from '@coreui/react';
import { useHistory } from 'react-router-dom';
import CategoryService from '../services/categories.service';
import LoaderButton from '../components/LoaderButton';
import BrandsService from '../services/brands.service';
import DefaultEntityService from '../services/default-entities.service';
import SpinnerWithContainer from '../components/SpinnerWithContainer';

const validationSchema = Yup.object().shape({
  category: Yup.string().required('Required'),
  comparisions: Yup.array().of(
    Yup.object().shape({
      brand1: Yup.string().notOneOf(
        ['-1', Yup.ref('brand2')],
        'Brands must not be same'
      ),
      brand2: Yup.string().notOneOf(
        ['-1', Yup.ref('brand1')],
        'Brands must not be same'
      ),
    })
  ),
});

const DefaultEntities = () => {
  let history = useHistory();

  // component state
  const [categories, setCategories] = useState([]);
  const [brands, setBrands] = useState([]);
  const [defaultEntities, setDefaultEntities] = useState(null);
  const [isloading, setIsloading] = useState({
    default: false,
    submit: false,
    categories: false,
    brands: false,
  });

  const saveDefaultEntities = async (value) => {
    const body = {
      category: value.category == '1' ? null : value.category,
      comparisions: value.comparisions.map((comparision) => ({
        brand1: comparision.brand1 == '1' ? null : comparision.brand1,
        brand2: comparision.brand2 == '2' ? null : comparision.brand2,
      })),
      shuffleComparisions: Boolean(value.shuffleComparisions),
    };
    console.log(`body`, body);

    setIsloading({ ...isloading, submit: true });
    try {
      const res = await DefaultEntityService.create(body);
      setIsloading({ ...isloading, submit: false });
      history.push('/categories');
    } catch (e) {
      setIsloading({ ...isloading, submit: false });
      console.log(e.response);
    }
  };

  // effect for getting categories and default entities
  useEffect(() => {
    getCategories();
    getDefaultEntities();
  }, []);

  // get selected category brand when user selects category
  useEffect(() => {
    if (defaultEntities?.category) {
      getBrands(defaultEntities.category);
    }
  }, [defaultEntities]);

  const getCategories = async () => {
    setIsloading({ ...isloading, categories: true });
    try {
      const res = await CategoryService.get();
      setCategories(res.data);
      setIsloading({ ...isloading, categories: false });
    } catch (e) {
      setIsloading({ ...isloading, categories: false });
      console.log('er', e);
    }
  };

  const getBrands = async (id) => {
    if (id && id !== '-1') {
      setIsloading({ ...isloading, brands: true });
      try {
        let res;
        if (id !== '1') res = await BrandsService.getByCategory(id);
        else res = await BrandsService.get();

        setBrands(res.data);
        setIsloading({ ...isloading, brands: false });
      } catch (e) {
        setIsloading({ ...isloading, brands: false });
        console.log('er', e);
      }
    }
  };

  const getDefaultEntities = async () => {
    setIsloading({ ...isloading, default: true });
    try {
      const { data } = await DefaultEntityService.get();
      console.log(`data`, data);
      setDefaultEntities(data);

      setIsloading({ ...isloading, default: false });
    } catch (e) {
      setIsloading({ ...isloading, default: false });
      console.log('error', e);
    }
  };

  if (isloading.categories || isloading.default || !defaultEntities) {
    return <SpinnerWithContainer />;
  }

  return (
    <>
      <h1>Default Comparisons</h1>

      <Formik
        initialValues={{
          category: defaultEntities.category || 1,
          shuffleComparisions: defaultEntities.shuffleComparisions ? 1 : 0,
          comparisions: defaultEntities.comparisions.map((comparision) => ({
            brand1:
              defaultEntities.category === '1'
                ? 1
                : comparision.brand1 === null
                ? 1
                : comparision.brand1,
            brand2:
              defaultEntities.category === '1'
                ? 2
                : comparision.brand2 === null
                ? 2
                : comparision.brand2,
          })),
        }}
        enableReinitialize
        validationSchema={validationSchema}
        onSubmit={saveDefaultEntities}
      >
        {({
          handleChange,
          handleSubmit,
          setFieldValue,
          values,
          errors,
          touched,
        }) => (
          <CForm className="" onSubmit={handleSubmit}>
            <CRow className="mb-5">
              <CCol md="6" className="offset-lg-3">
                <CFormGroup>
                  <h5>Categories</h5>
                  <CSelect
                    name="category"
                    value={values.category}
                    onChange={(evt) => {
                      setDefaultEntities((state) => ({
                        ...state,
                        category: evt.target.value,
                      }));
                      handleChange(evt);
                    }}
                  >
                    <option key={0} value={'-1'} defaultValue>
                      Select Category
                    </option>
                    <option key={1} value={'1'}>
                      Pick Randomly
                    </option>
                    {categories &&
                      categories.map((category) => {
                        return (
                          <option key={category._id} value={category._id}>
                            {category.name}
                          </option>
                        );
                      })}
                  </CSelect>
                </CFormGroup>
              </CCol>
            </CRow>

            {!isloading.brands ? (
              <FieldArray
                name="comparisions"
                render={({ push, remove }) => (
                  <div>
                    {values.comparisions.map((comparision, index) => (
                      <CFormGroup key={index}>
                        <CRow>
                          <CCol>
                            <CLabel>Brand 1</CLabel>
                            <CSelect
                              name={`comparisions[${index}].brand1`}
                              value={comparision.brand1}
                              onChange={handleChange}
                            >
                              <option key={0} value={-1} defaultValue>
                                Select Brand
                              </option>
                              <option key={1} value={1}>
                                Pick Randomly
                              </option>
                              {brands &&
                                brands.map((brand) => {
                                  return (
                                    <option
                                      key={brand._id}
                                      value={brand._id}
                                      disabled={values.category === '1'}
                                    >
                                      {brand.name}
                                    </option>
                                  );
                                })}
                            </CSelect>
                            {errors?.comparisions?.[index]?.brand1 &&
                              touched?.comparisions?.[index]?.brand1 && (
                                <CFormText
                                  color="danger"
                                  className="help-block"
                                >
                                  {errors.comparisions[index].brand1}
                                </CFormText>
                              )}
                          </CCol>

                          <CCol>
                            <CLabel>Brand 2</CLabel>
                            <CSelect
                              name={`comparisions[${index}].brand2`}
                              value={comparision.brand2}
                              onChange={handleChange}
                            >
                              <option key={0} value={-1} defaultValue>
                                Select Brand
                              </option>
                              <option key={1} value={2}>
                                Pick Randomly
                              </option>
                              {brands &&
                                brands.map((brand) => {
                                  return (
                                    <option
                                      key={brand._id}
                                      value={brand._id}
                                      disabled={values.category === '1'}
                                    >
                                      {brand.name}
                                    </option>
                                  );
                                })}
                            </CSelect>
                            {errors?.comparisions?.[index]?.brand2 &&
                              touched?.comparisions?.[index]?.brand2 && (
                                <CFormText
                                  color="danger"
                                  className="help-block"
                                >
                                  {errors.comparisions[index].brand2}
                                </CFormText>
                              )}
                          </CCol>

                          <div className="d-flex align-items-center">
                            <CButtonClose
                              title="Remove row"
                              onClick={() => remove(index)}
                            />
                          </div>
                        </CRow>
                      </CFormGroup>
                    ))}
                    <CButton
                      size="sm"
                      color="primary"
                      variant="outline"
                      onClick={() => push({ brand1: '', brand2: '' })}
                    >
                      Add
                    </CButton>
                    <hr />
                  </div>
                )}
              />
            ) : (
              <SpinnerWithContainer />
            )}

            <CCol>
              <CInputCheckbox
                id="randomize"
                onChange={() =>
                  setFieldValue(
                    'shuffleComparisions',
                    values.shuffleComparisions === 1 ? 0 : 1
                  )
                }
                checked={Boolean(values.shuffleComparisions)}
                disabled={
                  values.comparisions.length === 1 ||
                  Number(values.category) === 1
                }
              />
              <CLabel htmlFor="randomize">Shuffle comparisions</CLabel>
            </CCol>

            <LoaderButton
              title="Submit"
              className="option mt-4"
              color="primary"
              type={'submit'}
              shape="square"
              size="md"
              loading={isloading.submit}
            />
          </CForm>
        )}
      </Formik>
    </>
  );
};
export default DefaultEntities;
